// extracted by mini-css-extract-plugin
export default {"container":"AffiliateLink_container__AEutu","button":"AffiliateLink_button__UaRJw","deleteButton":"AffiliateLink_deleteButton__EJeI+"};